import { PdInput } from "./pd-input/PdInput.js";
//#region src/pd-input/pd-input.ts
var tag = "pd-input";
if (!customElements.get(tag)) customElements.define(tag, PdInput);
//#endregion
export { PdInput };
